import { useQuery } from 'react-query';
import { apiService } from '../../utils/api';
import { SpinnerOverlay } from '@/components/ui/Spinner';
import { Redirect } from 'react-router-dom';

const RevitAddingPage = () => {
  const { data, isFetching } = useQuery({
    queryKey: ['revitAddin'],

    queryFn: async () => {
      const response = await apiService.get(`/api/v1/revit-addin/`, { responseType: 'blob' });
      return response;
    },
    onSuccess: async (response) => {
      const contentDisposition = response.headers['content-disposition'];

      const fileNameMatch =
        contentDisposition &&
        contentDisposition.match(/filename=["']?([^"\s]+(?:\s[^"\s]+)*)(?=["']?)/);
      const fileName = fileNameMatch ? fileNameMatch[1] : 'revit-addin.msi';

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchInterval: false,
    retry: false,
    keepPreviousData: false,
  });

  if (isFetching) {
    return (
      <div className="size-full flex justify-center items-center">
        <div className="flex flex-col gap-6">
          <SpinnerOverlay size="lg" />
          <p className="text-color2">Stahování Revit addinu ...</p>
        </div>
      </div>
    );
  }

  if (data) {
    return <Redirect to="/" />;
  }
};
export default RevitAddingPage;
